<p>
  {{ "Help.find_help" | translate }}
  <a href="https://intercom.help/io-base/fr/collections/3633908-indasheet" target="_blank" translate>Help.here</a>
</p>
